import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { AlertCircle } from 'lucide-react';

const BookingSection = ({
  user,
  classData,
  spots,
  setSpots,
  showCancellationTerms,
  acceptedTerms,
  setAcceptedTerms,
  onBooking,
  onWaitlist
}) => {
  return (
    <>
      {classData.spots_available > 0 ? (
        <div className="space-y-4">
          {/* Spots Selector */}
          <div className="flex items-center justify-between bg-background p-4 rounded-sm border border-white/10">
            <span className="text-neutral-300">Number of spots:</span>
            <div className="flex items-center gap-3">
              <button
                onClick={() => setSpots(Math.max(1, spots - 1))}
                className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-lg font-bold"
                disabled={spots <= 1}
                data-testid="decrease-spots-btn"
              >
                -
              </button>
              <span className="text-xl font-bold w-8 text-center" data-testid="spots-count">{spots}</span>
              <button
                onClick={() => setSpots(Math.min(classData.spots_available, 10, spots + 1))}
                className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-lg font-bold"
                disabled={spots >= Math.min(classData.spots_available, 10)}
                data-testid="increase-spots-btn"
              >
                +
              </button>
            </div>
          </div>
          
          {spots > 1 && (
            <p className="text-sm text-primary text-center">
              Total: £{(classData.price * spots).toFixed(2)} for {spots} spots
            </p>
          )}

          {/* Cancellation Terms */}
          {showCancellationTerms && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              className="bg-background border border-warning/30 rounded-sm p-4"
            >
              <div className="flex items-start gap-3 mb-4">
                <AlertCircle className="w-5 h-5 text-warning mt-0.5" />
                <div>
                  <h4 className="font-bold text-warning mb-2">Cancellation Terms</h4>
                  <ul className="text-sm text-neutral-300 space-y-2">
                    <li>• <strong>Free cancellation:</strong> Up to 24 hours before class start</li>
                    <li>• <strong>Late cancellation:</strong> Within 24 hours - non-refundable</li>
                    <li>• <strong>No-shows:</strong> No refund will be issued</li>
                    <li>• <strong>Class changes:</strong> Full refunds for classes cancelled by T-Fit Inc</li>
                  </ul>
                </div>
              </div>
              <label className="flex items-center gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={acceptedTerms}
                  onChange={(e) => setAcceptedTerms(e.target.checked)}
                  className="w-5 h-5 rounded border-white/20 bg-background text-primary focus:ring-primary"
                  data-testid="accept-terms-checkbox"
                />
                <span className="text-sm text-neutral-300">
                  I have read and accept the cancellation terms
                </span>
              </label>
            </motion.div>
          )}
          
          <Button
            className="w-full bg-primary hover:bg-primary-hover font-bold py-6 text-lg"
            onClick={onBooking}
            data-testid="book-now-btn"
          >
            {showCancellationTerms ? 'CONFIRM BOOKING' : `BOOK ${spots > 1 ? spots + ' SPOTS' : 'NOW'}`}
          </Button>
        </div>
      ) : (
        <Button
          className="w-full bg-secondary hover:bg-secondary-hover font-bold py-6 text-lg"
          onClick={onWaitlist}
          data-testid="join-waitlist-btn"
        >
          JOIN WAITLIST
        </Button>
      )}

      {!user && (
        <p className="text-sm text-neutral-400 text-center">
          <Link to="/login" className="text-primary hover:underline">Login</Link> or <Link to="/register" className="text-primary hover:underline">register</Link> to book this class
        </p>
      )}
    </>
  );
};

export default BookingSection;
